import { render } from "./page-settings.vue?vue&type=template&id=58432149&scoped=true"
import script from "./page-settings.vue?vue&type=script&lang=js"
export * from "./page-settings.vue?vue&type=script&lang=js"

import "./page-settings.vue?vue&type=style&index=0&id=58432149&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58432149"]])

export default __exports__